import { render, staticRenderFns } from "./BuildSolar.vue?vue&type=template&id=ba2aa17c&scoped=true&"
import script from "./BuildSolar.vue?vue&type=script&lang=ts&"
export * from "./BuildSolar.vue?vue&type=script&lang=ts&"
import style0 from "./BuildSolar.vue?vue&type=style&index=0&id=ba2aa17c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2aa17c",
  null
  
)

export default component.exports